import React, { useState } from "react";

import { Row, Col } from "react-bootstrap";
import { FaCheck, FaLock } from "react-icons/fa";
import { FaMinus } from "react-icons/fa6";

import { PALETTE } from "../../common/ThemeConstants";
import Logo from "../../common/images/logo.png";
import { useNavigate } from "react-router-dom";
import PremiumTag from "../../common/components/PremiumTag";

export default function AccountSubscription({
  features,
  color,
  isPremium,
  roundedClassName = "rounded-md",
}) {
  const navigate = useNavigate();
  const [maxFeatures, setMaxFeatures] = useState(2)
  return (
    <div
      className={roundedClassName + " shadow m-auto"}
      style={{ maxWidth: 420, padding: 2, background: color }}
    >
      <div
        className={roundedClassName + " py-1 px-1"}
        style={{ width: "100%" }}
      >
        <Row className="my-1 m-auto" style={{ width: "100%" }}>
          <Col xs={7} className="text-start align-self-center px-0" style={{ paddingTop: 5 }}>
            <img src={Logo} alt="Logo" width={80} style={{ marginTop: -8, marginRight: 4 }} />
            {!isPremium && <PremiumTag />}
          </Col>
          <Col xs={2} className="text-center align-self-center px-0">
            {!isPremium && <p className="mb-0" style={{ fontSize: 13 }}>Base</p>}
          </Col>
          <Col xs={3} className="text-center align-self-center px-0">
            {!isPremium && <p className="mb-0" style={{ fontSize: 13, fontWeight: "bold" }}>Premium</p>}
            {isPremium && (
              <span
                className="px-1 py-1"
                style={{
                  fontSize: 10,
                  color: PALETTE.WHITE,
                  borderTopLeftRadius: 10,
                  borderBottomRightRadius: 10,
                  background: PALETTE.LINEARGRADIENT,
                  frontWeight: "bold"
                }}
              >Premium</span>
            )}
          </Col>
        </Row>
        {features.slice(0, maxFeatures).map((feature, idx) => (
          <Row key={idx} className="my-3 m-auto" style={{ width: "100%" }}>
            <Col xs={7} className="text-start align-self-center px-0">
              <p className="mb-0" style={{ fontSize: 14 }}>{feature.name}</p>
              <p className="mb-0" style={{ fontSize: 12, color: PALETTE.GRAY }}>
                {feature.description}
              </p>
            </Col>
            <Col xs={2} className="text-center align-self-center px-0">
              {!isPremium && (
                <>
                  {feature.free ? (
                    <>
                      <FaCheck size={18} color={PALETTE.DARK} />
                    </>
                  ) : (
                    <FaMinus size={18} color={PALETTE.DARK} />
                  )}
                </>
              )}
            </Col>
            <Col xs={3} className="text-center align-self-center px-0">
              {feature.premium ? (
                <>
                  <FaCheck size={18} color={!isPremium ? PALETTE.DARK : PALETTE.MAINCOLORHOVER} />
                  {isPremium && (
                    <FaCheck
                      size={18}
                      color={PALETTE.SECONDARYCOLORTRANSPARENT}
                      style={{ marginLeft: -18 }}
                    />
                  )}
                </>
              ) : (
                <FaMinus size={18} color={PALETTE.DARK} />
              )}
            </Col>

          </Row>
        ))}
        {maxFeatures < features.length && (
          <Row>
            <Col xs={12} className="text-center align-self-center px-0">
              <p
                style={{
                  fontSize: 14,
                  color: PALETTE.SECONDARYCOLORHOVER,
                  cursor: "pointer"
                }}
                onClick={() => isPremium ? setMaxFeatures(features.length) : navigate("/subscriptions")}>
                Scopri tutti i vantaggi Premium
              </p>
            </Col>
          </Row>
        )}
      </div>
    </div >
  );
}
